import React, { memo, useEffect } from "react";
import styled from "styled-components";
import { ApiError } from "../../services/api-errors";
import { useTranslation } from "react-i18next";
import * as Sentry from "@sentry/react";
import { getLocalStorageService } from "../../services/local-storage.service";
import i18n from "../../i18n";

interface IApiErrorViewProps {
  error: ApiError;
  isLayout?: boolean | false;
}

interface IStyled {
  isLayout?: boolean | false;
}

const ErrorStyle = styled.div<IStyled>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  height: ${(props) =>
    props.isLayout ? `calc(100vh - 142px)` : `calc(100vh - 60px)`};
  margin-top: ${(props) => (props.isLayout ? "-30px" : 0)};
  @media screen and (max-width: 768px) {
    height: ${(props) =>
      props.isLayout ? `calc(100vh - 154px)` : `calc(100vh - 60px)`};
  }
`;

const ErrorDescriptionStyle = styled.div`
  background-color: #e74c3c;
  color: #ffffff;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 50%;
  padding: 15px 22px;
  margin: 20px 0;

  @media screen and (max-width: 780px) {
    width: 90%;
    font-size: 16px;
    line-height: 19px;
  }
`;

const Error_ = (props: IApiErrorViewProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(
      getLocalStorageService().initLocalLanguage(
        `${process.env.REACT_APP_DEFAULT_LOCALE}`
      )!
    );
  }, []);

  let errorMessage = t("instabook.errors.error");
  if (typeof props.error.getMessage === "function") {
    errorMessage = props.error.getMessage();
  } else {
    Sentry.captureException(
      new Error(`getMessage is Not a function ${props.error}`),
      (scope) => {
        scope.setTag("getMessage", "notAFunction");
        scope.setContext("props.error: ", { ...props.error });
        return scope;
      }
    );
  }
  return (
    <ErrorStyle isLayout={props.isLayout}>
      <ErrorDescriptionStyle data-test="error-message">
        {errorMessage}
      </ErrorDescriptionStyle>
    </ErrorStyle>
  );
};

export const ApiErrorView = memo(Error_);
